import validator from "validator";

export const addCategoryValidation = (data) => {
  const error = {};
  if (validator.isEmpty(data.category)) {
    error.category = "Please enter category name";
  }
  return error;
};
